import { ChangeDetectorRef, Component, Input, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { NgxImageCompressService } from 'ngx-image-compress';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { AttestationModel } from '../attestation-details/model/attestationModel';
import { UploadDocumentsService } from './services/upload-documents.service';
import { EducationDocumentModel } from './model/documentModel';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { Lightbox } from 'ngx-lightbox';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentViewerComponent } from '../../../../../shared/shared-components/modal/document-viewer/document-viewer.component';
import { PdfViewerComponent } from '../../../../../shared/shared-components/modal/pdf-viewer/pdf-viewer.component';
import { GoogleAnalyticsService } from '../../../../../shared/sharedServices/google-analytics.service';
import { decrypt } from '../../../../../utilities/utilityFunctions';
import { PucaComponent } from '../../puca.component';
import { PucaDataService } from '../../services/puca-data.service';
@Component({
  selector: 'kt-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent implements OnInit, OnDestroy {
  @Input('dasApplicationData') dasApplicationData: AttestationModel = new AttestationModel();
  @Input('dropdownValuesForDas') dropdownValuesForDas: any;
  public applicationId: number;
  public documentCategory: string;
  public personalDocumentList: any = []
  public educationDocumentList: Array<EducationDocumentModel> = []
  public degreeDetailsDocumentList: any = [];
  public isPersonalDocumentUpload: boolean = false;
  public isEducationDocumentUpload: boolean = false;
  public isOptionalDocumentUplaod: boolean = false;
  public educationDetails:any;
  private selectedFilePayload: any;
  private attachmentBase64: string;
  public isImageAlert: boolean = false;
  public uploadloader: boolean = false;
  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public personalLoader: any = [];
  public educationLoader: any = [];
  public educationDocLoader: any = []
  public optionalLoader: any = [];
  public userDocumentList: any = [];
  public optionalDocumentList: any = [];
  public docList: any = [];
  public refreshEducation: boolean = false;
  public isError: boolean = false;
  public isPersonalDocError: boolean;
  public isEducationDocError: boolean;
  public alertType: string = '';
  public errorMsg: string = '';
  public loader: boolean;
  public formView: string;
  public isDegreeVerified:boolean = false;
  user_Doc: SafeResourceUrl;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  @Input() isAdmin: boolean = false;

  public userIdentityNum = JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? JSON.parse(decrypt(localStorage.getItem('loginDetails'))).cnic : JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userName;
  public filType = JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? 'CNIC' : 'Passport';
  public userCountry = JSON.parse(decrypt(localStorage.getItem('primaryNationality'))).countryName;
  // public cnicTypeDocuments: any[] = [
  //   { label: 'CNIC FRONT', value: 1 },
  //   { label: 'CNIC BACK', value: 2 }
  // ];
  public dropdownValues: any = { documentType: '' };
  // public passportTypeDocument: any = [
  //   { label: 'Passport', value: 3 },
  // ]
  constructor(private parentComp: PucaComponent, private cdr: ChangeDetectorRef, private loaderService: LoaderService,
    private matDialog: MatDialog,private gaService:GoogleAnalyticsService,
    public _snackBar: MatSnackBar, private router: Router, private dasDataService: PucaDataService, private sanitizer: DomSanitizer,
    private uploadSerivce: UploadDocumentsService, 
    // private ng2ImgMax: Ng2ImgMaxService, 
    private imageCompress: NgxImageCompressService,
    private _lightbox: Lightbox) { }

  ngOnInit() {
    window.scroll(0, 0)
    this.gaService.setPage('/form','ESP Page');
    this.formView = this.parentComp.formType
    let arrayObj = this.dropdownValuesForDas.documentChecklist.map(item => {
      return {
        label: item.title,
        value: item.id
      };
    });
    this.dropdownValues.documentType = arrayObj
    this.getEducationList();
    this.getDocumentList('CMNPROF');
    this.getDocumentList('DAS');
    if (JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1) {
      this.personalDocumentList = [
        {
          fileName: 'Front',
          fileCat: 'Front',
          FileDecs:'Copy of CNIC',
          identificationNumber: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? JSON.parse(decrypt(localStorage.getItem('loginDetails'))).cnic : JSON.parse(decrypt(localStorage.getItem('loginDetails'))).passport,
          fileType: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? 'CNIC' : 'Passport',
          country: JSON.parse(decrypt(localStorage.getItem('primaryNationality'))).countryName
        },
        {
          fileName: 'Back',
          fileCat: 'Back',
          FileDecs:'Copy of CNIC',
          identificationNumber: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? JSON.parse(decrypt(localStorage.getItem('loginDetails'))).cnic : JSON.parse(decrypt(localStorage.getItem('loginDetails'))).passport,
          fileType: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? 'CNIC' : 'Passport',
          country: JSON.parse(decrypt(localStorage.getItem('primaryNationality'))).countryName
        },
      ]
    } else {
      this.personalDocumentList = [
        {
          fileName: 'Front',
          fileCat: 'Front',
          FileDecs:'Copy of Passport/Travel Document',
          identificationNumber: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userName,
          fileType: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1 ? 'CNIC' : 'Passport',
          country: JSON.parse(decrypt(localStorage.getItem('primaryNationality'))).countryName
        },
      ]

    }
  }

  ngOnDestroy() {
    this.dasDataService.formView = undefined;
    this.dasDataService.applicationId = undefined;
  }

  public goNext(type) {
    if (this.formView != 'view') {
      for (let personalIndex = 0; personalIndex < this.personalDocumentList.length; personalIndex++) {
        if (this.personalDocumentList[personalIndex].docId == undefined) {
          this.errorMsg = 'Please Upload All Mandatory Documents';
          this.alertType = 'error';
          this.isPersonalDocError = true;
          window.scroll(0, 150)
          return
        }
      }

      for (let educationIndex = 0; educationIndex < this.educationDocumentList.length; educationIndex++) {
        if (this.educationDocumentList[educationIndex].docList.length == 0) {
          this.errorMsg = 'Please Upload All Mandatory Documents';
          this.alertType = 'error';
          window.scroll(0, 300)
          this.isPersonalDocError = false;
          this.isEducationDocError = true;
          return
        }
      }
      for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
        for (let j = 0; j < this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo.length; j++) {
          delete this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo[j].documentTypeCodeValue;
        }
      }
      let payload = {
        data: {
          isCheckNadraDetail: true,
          dasApplicationDto: this.dasApplicationData.dasApplicationDto
        }
      }
      this.loader = true;
      this.loaderService.setValue(this.loader)
      if (this.formView == 'pucaRevision') {
        payload.data.dasApplicationDto.applicationStatusCodeId = 600827
      }
      this.uploadSerivce.saveApplicationData(payload).subscribe(
        async (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.loader = false;
            this.loaderService.setValue(this.loader)
            await this.parentComp.getDasApplication(this.dasApplicationData.dasApplicationDto.id);
            if (type == 'next') {
              this.parentComp.goNext();
              this.cdr.detectChanges();
            } else if (type == 'save') {
              this.router.navigate(['/dashboard'])
            }
          } else {
            this.loader = false;
            this.loaderService.setValue(this.loader)
            this.cdr.detectChanges();

          }
        },
        (err) => {
          this.loader = false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
        }
      )
    } else {
      this.parentComp.goNext();
    }

  }

  public addFiles(type) {
    if (type = 'optional') {
      this.documentCategory = 'ApplicationForm'
      this.applicationId = this.dasApplicationData.dasApplicationDto.id;
      this.isOptionalDocumentUplaod = true;
    }


  }

  public getEducationList() {
    this.degreeDetailsDocumentList = [];
    for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
      this.degreeDetailsDocumentList.push({
        degreeName: this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.qualificationLevel,
        subjectName: this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.countryId == 1 ? this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.degreeProgramName : this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.otherProgramTitle,
        docList: this.dasApplicationData.dasApplicationDto.dasDegrees[i].degreeInfo,
      })
      // this.educationDetails =
      if(this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified){
      this.isDegreeVerified =  true
    }
    }
    this.degreeDetailsDocumentList.docList = this.dasApplicationData.dasApplicationDto.dasDegrees;
    this.degreeDetailsDocumentList.docList = this.dasApplicationData.dasApplicationDto.dasDegrees;
    let typList = []
    for (let i = 0; i < this.degreeDetailsDocumentList.length; i++) {
      for (let j = 0; j < this.degreeDetailsDocumentList[i].docList.length; j++) {
        this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeValue = this.dropdownValuesForDas.map['6005'].find(element => {
          return element.value == this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId;
        });
        typList.push(this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeValue)
      }

    }
    const uniqueArray = typList.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === typList.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    for (let i = 0; i < this.degreeDetailsDocumentList.length; i++) {
      for (let j = 0; j < this.degreeDetailsDocumentList[i].docList.length; j++) {
        if (this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == 60051) {
          this.educationDocumentList.push({
            documentType: 'Copy of Degree',
            qualificationLevel: this.degreeDetailsDocumentList[i].degreeName,
            programTitle: this.degreeDetailsDocumentList[i].subjectName,
            docList: []
          })
          for(let j=0; j < this.educationDocumentList.length;j++){
          for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
        if(this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
          this.dasApplicationData.dasApplicationDto.dasDegrees[i].exactDegreeTitle == this.educationDocumentList[j].programTitle){
       this.educationDocumentList[j].isDegreeVerified=this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified
      }
    }
    }
        }
        if (this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == 60052 ||
          this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == 60051) {
          this.educationDocumentList.push({
            documentType: 'Copy of Transcript',
            qualificationLevel: this.degreeDetailsDocumentList[i].degreeName,
            programTitle: this.degreeDetailsDocumentList[i].subjectName,
            docList: []
          })
          for(let j=0; j < this.educationDocumentList.length;j++){
          for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
              if(this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[i].exactDegreeTitle == this.educationDocumentList[j].programTitle){
             this.educationDocumentList[j].isDegreeVerified=this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified
            }
          }
          }
        }
        if (this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == 60053) {
          this.educationDocumentList.push({
            documentType: 'Copy of Provisional Certificate',
            qualificationLevel: this.degreeDetailsDocumentList[i].degreeName,
            programTitle: this.degreeDetailsDocumentList[i].subjectName,
            docList: []
          })
          for(let j=0; j < this.educationDocumentList.length;j++){
          for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
              if(this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[i].exactDegreeTitle == this.educationDocumentList[j].programTitle){
             this.educationDocumentList[j].isDegreeVerified=this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified
            }
          }
          }
        }
        if (this.degreeDetailsDocumentList[i].docList[j].documentTypeCodeId == 60054) {
          this.educationDocumentList.push({
            documentType: 'Copy of Equivalence Certificate of HEC',
            qualificationLevel: this.degreeDetailsDocumentList[i].degreeName,
            programTitle: this.degreeDetailsDocumentList[i].subjectName,
            docList: []
          })
          for(let j=0; j < this.educationDocumentList.length;j++){
          for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
              if(this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified &&
                this.dasApplicationData.dasApplicationDto.dasDegrees[i].exactDegreeTitle == this.educationDocumentList[j].programTitle){
             this.educationDocumentList[j].isDegreeVerified=this.dasApplicationData.dasApplicationDto.dasDegrees[i].educationHistoryDto.verified
            }
          }
          }
        }
      }
    }
    this.educationDocumentList = this.educationDocumentList.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === this.educationDocumentList.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
  }

  public getUploadData(event) {
    if (event != 'cancel') {
      if (event.documentCategory == 'ApplicationForm') {
        this.optionalDocumentList.push(
          {
            fileName: event.reqPayload.data.title,
            documentType: 'Optional',
            docId: event.resPayload.documentId,
          }
        )
        this.isOptionalDocumentUplaod = false;

      }
    } else {
      this.isOptionalDocumentUplaod = false;
    }
  }

  public getDocumentList(acronym) {
    this.loader = true;
    this.loaderService.setValue(this.loader)
    let payload = {
      data: {
        applicationId: JSON.parse(decrypt(localStorage.getItem('loginDetails'))).id,
        processAcronym: acronym
      }
    }
    this.uploadSerivce.getDocumentList(payload).subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.userDocumentList = res.data
          for (let j = 0; j < this.userDocumentList.length; j++) {
            if (this.userDocumentList[j].category == 'Personal Tab') {
              for (let i = 0; i < this.personalDocumentList.length; i++) {
                if (this.personalDocumentList[i].FileDecs == this.userDocumentList[j].title &&
                  this.personalDocumentList[i].fileName == this.userDocumentList[j].description) {
                  this.personalDocumentList[i].docId = this.userDocumentList[j].documentId
                }
              }
            }
            else if (this.userDocumentList[j].category == 'Education') {
              for (let k = 0; k < this.educationDocumentList.length; k++) {
                this.educationDocumentList[k].documentFullTitle = (this.educationDocumentList[k].qualificationLevel + ' - ' + this.educationDocumentList[k].programTitle + ' - ' + this.educationDocumentList[k].documentType)
                if (this.educationDocumentList[k].documentFullTitle == this.userDocumentList[j].title) {
                  this.educationDocumentList[k].docList.push({
                    docId: this.userDocumentList[j].documentId,
                    title: this.userDocumentList[j].title
                  })
                }
              }
            }
            else if (this.userDocumentList[j].category == 'ApplicationForm') {
              this.optionalDocumentList.push({
                docId: this.userDocumentList[j].documentId,
                fileName: this.userDocumentList[j].title,
                documentType: 'Optional'
              })
            }

          }
          this.loader = false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
        } else {
          this.loader = false;
          this.loaderService.setValue(this.loader)
        }
      }
    )
  }

  public downloadDocument(file, acronym, index, reqType,downloadType) {
    if (reqType == 'personal') {
      this.personalLoader[index] = true;
    } else if (reqType == 'optional') {
      this.optionalLoader[index] = true;
    } else if (reqType == 'education') {
      this.educationLoader[index] = true;
    }
    if (file.docId) {
      let payload = {
        data: {
          documentId: file.docId,
          acronym: acronym
        }
      }
      this.uploadSerivce.getAttachmentByDocumentId(payload).subscribe(
        (res: HecResponse) => {
          if (reqType == 'personal') {
            this.personalLoader[index] = false;
          } else if (reqType == 'optional') {
            this.optionalLoader[index] = false;
          }
          else if (reqType == 'education') {
            this.educationLoader[index] = false;
          }
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            if(downloadType == 'view'){
            if (res.data.path.toLowerCase().split('.').pop() != 'pdf') {
              this.ModalComponent(DocumentViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-two')
            } else {
              this.ModalComponent(PdfViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-three')
            }
          }else{
            this.saveFile(res.data.content,file,res.data.path.toLowerCase().split('.').pop())
          }
          }
        }
      )
    }
  }

  private saveFile(base64, fileData,fileType) {
    const base_64 = base64.substring(base64.indexOf(',') + 1);
    const contentType = fileType;
    const fileName = fileData.fileName ? fileData.fileName : fileData.title;
    const fileExt = '.' + contentType.substring(contentType.indexOf('/') + 1);

    const blob = CommonHelper.base64toBlob(base_64, contentType);
    const blobUrl = URL.createObjectURL(blob);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
    }
    else {
      let a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName + fileExt;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  public openFile(file): void {
    // open lightbox
    const album = {
      src: file,
    };
    const albums = []
    albums.push(album)
    this._lightbox.open(file, 0);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  public deleteUploadDoc(id, index, type, acronym, eduDocIndex?) {
    this.uploadloader = true;
    if (type == 'personal') {
      this.personalLoader[index] = true;
    } else if (type == 'optional') {
      this.optionalLoader[index] = true;
    } else if (type == 'education') {
      this.educationLoader[index] = true;
    } else if (type == 'eudcation' && eduDocIndex != undefined) {
      this.educationDocLoader[eduDocIndex] = true;
    }
    let payload = {
      data: {
        documentId: id,
        acronym: acronym
      }
    }
    this.uploadSerivce.deleteDocument(payload).subscribe(
      (res: HecResponse) => {
        if (type == 'personal') {
          this.personalLoader[index] = false;
        } else if (type == 'optional') {
          this.optionalLoader[index] = false;
        } else if (type == 'education') {
          this.educationLoader[index] = false;
        } else if (type == 'eudcation' && eduDocIndex != undefined) {
          this.educationDocLoader[eduDocIndex] = false;
        }
        this.uploadloader = false;
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (type == 'personal') {
            this.personalDocumentList[index].docId = undefined;
            this.cdr.detectChanges();
          } else if (type == 'optional') {
            this.optionalDocumentList.splice(index, 1)
            this.cdr.detectChanges();
          }
          else if (type == 'education') {
            this.educationDocumentList[index].docList.splice(eduDocIndex, 1)
            this.cdr.detectChanges();
          }
        }
      }
    )
  }

  public async changeFileSelection(e: FileList, doc, category, acronym, index) {
    let image = e[0];
    let test: File;
    let file = e[0];
    if (this.isValidFile(file)) {
      this.cdr.detectChanges();
      if (file.type !== 'application/pdf') {
        // this.ng2ImgMax.compressImage(image, 0.575).subscribe(
        //   async result => {
        //     test = result;
        //     await this.setAttachmentsPayload(result);
        //     this.uploadAttachment(doc, category, acronym, index);

        //   },
        //   error => {
        //     this.cdr.detectChanges();
        //   }
        // );
        const reader = new FileReader();
      reader.onload = async () => {
        const imageBase64 = reader.result as string;
      
        // Compress image (needs full base64 URI)
        this.imageCompress.compressFile(imageBase64, -1, 50, 50)
          .then(async (compressedImage: string) => {
            // ✅ Remove the prefix after compression
            const strippedBase64 = compressedImage.replace(/^data:image\/[a-z]+;base64,/, '');
      
            await this.setAttachmentsPayload2(strippedBase64); // now clean
          })
          .catch((error) => {
            this.cdr.detectChanges();
          });
      };
      reader.readAsDataURL(file);
      } else {
        await this.setAttachmentsPayload(image);
        this.uploadAttachment(doc, category, acronym, index);

      }
    } else {
      e=undefined
      file=undefined
      this.fileUploader.nativeElement.value = null

    }
  }

  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.isImageAlert = true;
      this._snackBar.open('Invalid File Name', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    else if (fileSizeinKB > this.maxSize) {
      this.isImageAlert = true
      this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);
      return false;
    }
    return true;
  }


  private async setAttachmentsPayload(file) {
    this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  }
  private async setAttachmentsPayload2(base64: string) {
		this.attachmentBase64 = base64;
	}

  private uploadAttachment(doc, category, acronym, index) {
    this.uploadloader = true;
    if (category == 'Personal Tab') {
      this.personalLoader[index] = true;
    } else if (category == 'ApplicationForm') {
      this.optionalLoader[index] = true;
    } else if (category == 'Education') {
      this.educationLoader[index] = true;
    }
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;

    let payload = {
      data: {
        applicationId: JSON.parse(localStorage.getItem('loginDetails')).id,
        addedBy: decrypt(localStorage.getItem('name')),
        content: this.selectedFilePayload,
        processAcronym: acronym,
        category: category,
        title: doc.FileDecs ? doc.FileDecs : doc.qualificationLevel + ' - ' + doc.programTitle + ' - ' + doc.documentType,
        description: doc.fileName ? doc.fileName : doc.qualificationLevel + ' - ' + doc.programTitle + ' - ' + doc.documentType,
      }
    }
    this.uploadSerivce.uploadDocument(payload)
      .subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.uploadloader = false;

            if (category == 'Personal Tab') {
              this.personalLoader[index] = false;
              this.personalDocumentList[index].docId = res.data.documentId
            } else if (category == 'ApplicationForm') {
              this.optionalLoader[index] = false;
            } else if (category == 'Education') {
              if (this.educationDocumentList[index].docList.length != 0) {
                this.educationDocumentList[index].docList.push({
                  docId: res.data.documentId,
                  title: payload.data.title
                })
              } else {
                this.degreeDetailsDocumentList = [];
                this.educationDocumentList = [];
                this.getEducationList();
                this.getDocumentList('CMNPROF');
              }
              this.educationLoader[index] = false;
              this.cdr.detectChanges();

            }
            this.cdr.detectChanges();
          }
          else {
            if (category == 'Personal Tab') {
              this.personalLoader[index] = false;
            } else if (category == 'ApplicationForm') {
              this.optionalLoader[index] = false;
            } else if (category == 'Education') {
              this.educationLoader[index] = false;
            }
          }
        },
        (err) => {
          if (category == 'Personal Tab') {
            this.personalLoader[index] = false;
          } else if (category == 'ApplicationForm') {
            this.optionalLoader[index] = false;
          } else if (category == 'Education') {
            this.educationLoader[index] = false;
          }
        }
      )
  }

  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          resolve(null);
        })
    })
  }

  public goBack() {
    this.parentComp.goBack('back');
    this.cdr.detectChanges();
  }

  public cancelAttestaion() {
	if(this.isAdmin){
		this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
	  }
	  else{
		this.router.navigate(['/'])
	  }
  }

  public ModalComponent(component, imageType, imageContent, backdropClass?, panelClass?) {
    const dialogRef = this.matDialog.open(component, {
      width: '70vw',
      height: '60vh',
      backdropClass: backdropClass,
      panelClass: panelClass,
      disableClose: true,
      autoFocus: false,
      data: { imageType: imageType, imageContent: imageContent }
    });
  }

}
